/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Outline_Opacity_LabelInputs */



/**
* | output |
* | --- |
* | "Outline Opacity" |
*
* @param {Video_Export_Outline_Opacity_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_outline_opacity_label = /** @type {((inputs?: Video_Export_Outline_Opacity_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Outline_Opacity_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Opacite du contour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Konturdeckkraft")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opacità del contorno")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Прозрачность контура")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opacidad del contorno")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("轮廓不透明度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アウトラインの不透明度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रूपरेखा अपारदर्शिता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opacidade do contorno")
	return /** @type {LocalizedString} */ ("Outline Opacity")
});